module.exports = __webpack_public_path__ + "static/img/events-main-img.cbfec396.svg";